import script from "./ConsentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&setup=true&lang=js"

import "./ConsentBanner.vue?vue&type=style&index=0&id=0d5b6177&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5b6177"]])

export default __exports__